<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Proficiency</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">
    <div class="form-group">
      <label for="nameInput">Name</label>
      <input id="nameInput" type="text" class="form-control" name="name"
             required
             [(ngModel)]="proficiency.name">
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>
    <div class="form-group">
      <label for="iconInitialsInput">Icon Initials</label>
      <input id="iconInitialsInput" type="text" class="form-control" name="icon_initials"
             required maxlength="2"
             [(ngModel)]="proficiency.icon_initials">
      <small class="form-text">2 characters max</small>
      <div class="form-text text-danger">{{ errors.icon_initials }}</div>
    </div>
    <div class="form-group">
      <label for="iconColorHexSelect">Icon Color</label>
      <app-color-picker [id]="'iconColorHexSelect'"
                        [(content)]="proficiency.icon_color_hex"
                        [cpPosition]="'top-right'"></app-color-picker>
      <div class="form-text text-danger">{{ errors.icon_color_hex }}</div>
    </div>
    <div class="form-group">
      <label for="create_alert_on_expiration">
        Should an alert be created on the customer's account when this proficiency expires?
      </label>
      <select class="custom-select"
              id="create_alert_on_expiration"
              name="create_alert_on_expiration"
              [(ngModel)]="proficiency.create_alert_on_expiration">
        <option [ngValue]="false">No</option>
        <option [ngValue]="true">Yes</option>
      </select>
      <div class="form-text text-danger">{{ errors.create_alert_on_expiration }}</div>
    </div>
    <div *ngIf="proficiency.create_alert_on_expiration" class="indented-subsection">
      <div class="form-group">
        <label for="expiration_alert_color_hex">
          Expiration alert color
        </label>
        <app-color-picker [id]="'expiration_alert_color_hex'"
                          [(content)]="proficiency.expiration_alert_color_hex"
                          [cpPosition]="'top-right'"></app-color-picker>
        <div class="form-text text-danger">{{ errors.expiration_alert_color_hex }}</div>
      </div>
      <div class="form-group">
        <label for="expiration_alert_prevents_check_in">
          Should the alert prevent the customer from checking in while active?
        </label>
        <select class="custom-select"
                id="expiration_alert_prevents_check_in"
                name="expiration_alert_prevents_check_in"
                [(ngModel)]="proficiency.expiration_alert_prevents_check_in">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
        <div class="form-text text-danger">{{ errors.expiration_alert_prevents_check_in }}</div>
      </div>
      <div class="form-group">
        <label for="expiration_alert_has_alert_icon">
          Should the alert add an alert icon to the customer while active?
        </label>
        <select class="custom-select"
                id="expiration_alert_has_alert_icon"
                name="expiration_alert_has_alert_icon"
                [(ngModel)]="proficiency.expiration_alert_has_alert_icon">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
        <small class="form-text text-muted">
          The alert icon (a triangle with an exclamation point) will appear next to the customer's name on the Check-In Site and event participant list.
        </small>
        <div class="form-text text-danger">{{ errors.expiration_alert_has_alert_icon }}</div>
      </div>
    </div>
    <div class="form-group">
      <label for="hasNoCheckInExpirationMonths">
        Does this proficiency expire if a customer has not checked in within a set time period?
      </label>
      <select class="custom-select"
              id="hasNoCheckInExpirationMonths" name="hasNoCheckInExpirationMonths"
              [(ngModel)]="hasNoCheckInExpirationMonths">
        <option [ngValue]="false">No</option>
        <option [ngValue]="true">Yes</option>
      </select>
    </div>
    <div class="indented-subsection" *ngIf="hasNoCheckInExpirationMonths">
      <div class="form-group">
        <label for="no_check_in_expiration_months">
          How long can a customer go without checking in before this proficiency expires?
        </label>
        <div class="input-group">
          <input class="form-control"
                 id="no_check_in_expiration_months" name="no_check_in_expiration_months"
                 min="1" step="1"
                 [(ngModel)]="proficiency.no_check_in_expiration_months">
          <div class="input-group-append">
            <span class="input-group-text">months</span>
          </div>
        </div>
        <div class="form-text text-danger">{{ errors.no_check_in_expiration_months }}</div>
      </div>
    </div>
    <div class="form-group">
      <label for="hasExpirationAfterGrantedByDocumentDays">
        Does this proficiency expire a set time period after is it granted by a document?
      </label>
      <select class="custom-select"
              id="hasExpirationAfterGrantedByDocumentDays"
              name="hasExpirationAfterGrantedByDocumentDays"
              [(ngModel)]="hasExpirationAfterGrantedByDocumentDays">
        <option [ngValue]="false">No</option>
        <option [ngValue]="true">Yes</option>
      </select>
    </div>
    <div class="indented-subsection" *ngIf="hasExpirationAfterGrantedByDocumentDays">
      <div class="form-group">
        <label for="expiration_after_granted_by_document_days">
          How long after it is granted by a document does the proficiency expire?
        </label>
        <div class="input-group">
          <input class="form-control"
                 id="expiration_after_granted_by_document_days"
                 name="expiration_after_granted_by_document_days"
                 min="1" step="1"
                 [(ngModel)]="proficiency.expiration_after_granted_by_document_days">
          <div class="input-group-append">
            <span class="input-group-text">days</span>
          </div>
        </div>
        <div class="form-text text-danger">{{ errors.expiration_after_granted_by_document_days }}</div>
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
